import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Tab, Nav, Card, Button, Badge, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const IITJAMBiotechPage = () => {
  const [syllabusData, setSyllabusData] = useState([]);
  const [papersData, setPapersData] = useState([]);
  const [booksData, setBooksData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Simulate fetching data from database
  useEffect(() => {
    // In a real application, these would be API calls
    const fetchData = () => {
      setTimeout(() => {
        setSyllabusData([
          { id: 1, title: 'General Biology', topics: ['Cell Biology', 'Genetics', 'Evolution', 'Ecology', 'Physiology', 'Taxonomy'] },
          { id: 2, title: 'Biochemistry', topics: ['Biomolecules', 'Enzymology', 'Metabolism', 'Bioenergetics'] },
          { id: 3, title: 'Molecular Biology', topics: ['DNA Replication', 'Transcription', 'Translation', 'Gene Regulation'] },
          { id: 4, title: 'Microbiology', topics: ['Bacterial Classification', 'Microbial Growth', 'Microbial Genetics'] },
          { id: 5, title: 'Immunology', topics: ['Immune System', 'Antigens & Antibodies', 'Immune Response'] },
        ]);
        
        setPapersData([
          { id: 1, year: '2024', paperLink: '#', answerKeyLink: '#' },
          { id: 2, year: '2023', paperLink: '#', answerKeyLink: '#' },
          { id: 3, year: '2022', paperLink: '#', answerKeyLink: '#' },
          { id: 4, year: '2021', paperLink: '#', answerKeyLink: '#' },
          { id: 5, year: '2020', paperLink: '#', answerKeyLink: '#' },
          { id: 6, year: '2019', paperLink: '#', answerKeyLink: '#' },
          { id: 7, year: '2018', paperLink: '#', answerKeyLink: '#' },
        ]);
        
        setBooksData([
          { id: 1, title: 'Lehninger Principles of Biochemistry', author: 'David L. Nelson & Michael M. Cox', coverImg: '/api/placeholder/200/300', rating: 4.8 },
          { id: 2, title: 'Molecular Biology of the Cell', author: 'Bruce Alberts et al.', coverImg: '/api/placeholder/200/300', rating: 4.7 },
          { id: 3, title: 'Cell and Molecular Biology', author: 'Gerald Karp', coverImg: '/api/placeholder/200/300', rating: 4.6 },
          { id: 4, title: 'Microbiology', author: 'Prescott, Harley & Klein', coverImg: '/api/placeholder/200/300', rating: 4.5 },
          { id: 5, title: 'Immunology', author: 'Kuby', coverImg: '/api/placeholder/200/300', rating: 4.6 },
        ]);
        
        setLoading(false);
      }, 1000);
    };
    
    fetchData();
  }, []);

  const internships = [
    {
      id: 1,
      title: "AI in Genomic Analysis",
      description: "Work with cutting-edge AI tools to analyze genomic data and identify patterns related to disease markers and genetic variations.",
      duration: "3 months",
      stipend: "₹15,000/month",
      requirements: ["Basic knowledge of Python", "Understanding of molecular biology", "Statistics fundamentals"]
    },
    {
      id: 2,
      title: "Bioprocess Optimization using ML",
      description: "Apply machine learning algorithms to optimize bioprocesses in pharmaceutical production and improve yield.",
      duration: "6 months",
      stipend: "₹20,000/month",
      requirements: ["Prior experience with any ML framework", "Understanding of bioprocessing", "Good analytical skills"]
    },
    {
      id: 3,
      title: "Drug Discovery with Deep Learning",
      description: "Participate in our drug discovery program using deep learning to predict drug-protein interactions and potential candidates.",
      duration: "4 months",
      stipend: "₹18,000/month",
      requirements: ["Knowledge of neural networks", "Basic understanding of pharmacology", "Experience with PyTorch or TensorFlow"]
    }
  ];

  return (
    <div className="iit-jam-biotech-page">
      {/* Hero Section */}
      <section className="hero-section text-white py-5 my-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="hero-content">
                <h1 className="display-4 fw-bold">Master IIT-JAM Biotechnology</h1>
                <p className="lead my-4">Comprehensive coaching with hands-on internship opportunities in cutting-edge biotechnology and AI applications</p>
                <div className="d-flex gap-3">
                  <Button variant="light" size="lg">Enroll Now</Button>
                  <Button variant="outline-light" size="lg">Learn More</Button>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="hero-image text-center">
                <img src="/api/placeholder/500/350" alt="Students in biotech lab" className="img-fluid rounded shadow" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Coaching Information Section with Tabs */}
      <section className="coaching-section py-5 bg-light">
        <Container>
          <div className="section-heading text-center mb-5">
            <h2 className="fw-bold">IIT-JAM Biotechnology Coaching</h2>
            <p className="text-muted">Comprehensive preparation for one of India's most competitive exams</p>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-3">Loading course materials...</p>
            </div>
          ) : (
            <Tab.Container id="coaching-tabs" defaultActiveKey="syllabus">
              <Nav variant="pills" className="nav-tabs-custom justify-content-center mb-4">
                <Nav.Item>
                  <Nav.Link eventKey="syllabus">Syllabus</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="papers">Previous Papers</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="books">Reference Books</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="program">Our Program</Nav.Link>
                </Nav.Item>
              </Nav>
              
              <Tab.Content>
                {/* Syllabus Tab */}
                <Tab.Pane eventKey="syllabus">
                  <div className="syllabus-container">
                    <Row>
                      {syllabusData.map(unit => (
                        <Col md={6} lg={4} key={unit.id} className="mb-4">
                          <Card className="h-100 shadow-sm">
                            <Card.Body>
                              <Card.Title className="fw-bold">{unit.title}</Card.Title>
                              <ul className="mt-3">
                                {unit.topics.map((topic, index) => (
                                  <li key={index}>{topic}</li>
                                ))}
                              </ul>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Tab.Pane>
                
                {/* Previous Papers Tab */}
                <Tab.Pane eventKey="papers">
                  <div className="papers-container">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table-light">
                          <tr>
                            <th>Year</th>
                            <th>Question Paper</th>
                            <th>Answer Key</th>
                          </tr>
                        </thead>
                        <tbody>
                          {papersData.map(paper => (
                            <tr key={paper.id}>
                              <td>{paper.year}</td>
                              <td>
                                <Button variant="link" href={paper.paperLink}>
                                  Download Paper
                                </Button>
                              </td>
                              <td>
                                <Button variant="link" href={paper.answerKeyLink}>
                                  Download Answer Key
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Tab.Pane>
                
                {/* Reference Books Tab */}
                <Tab.Pane eventKey="books">
                  <div className="books-container">
                    <Row className="g-4">
                      {booksData.map(book => (
                        <Col md={6} lg={4} key={book.id}>
                          <Card className="h-100 book-card shadow-sm">
                            <Row className="g-0">
                              <Col xs={4}>
                                <img src={book.coverImg} alt={book.title} className="img-fluid rounded-start h-100 object-fit-cover" />
                              </Col>
                              <Col xs={8}>
                                <Card.Body>
                                  <Card.Title className="h5">{book.title}</Card.Title>
                                  <Card.Text className="text-muted">{book.author}</Card.Text>
                                  <div className="d-flex align-items-center mt-2">
                                    <span className="me-2">Rating:</span>
                                    <Badge bg="success">{book.rating}/5.0</Badge>
                                  </div>
                                </Card.Body>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Tab.Pane>
                
                {/* Our Program Tab */}
                <Tab.Pane eventKey="program">
                  <Row>
                    <Col lg={6} className="mb-4">
                      <div className="program-features">
                        <h3 className="h4 mb-4">Our Comprehensive Program Features</h3>
                        <ul className="feature-list">
                          <li>
                            <div className="d-flex align-items-center mb-3">
                              <div className="feature-icon me-3">📚</div>
                              <div>
                                <h4 className="h5 mb-1">Expert Faculty</h4>
                                <p className="mb-0">Learn from IIT alumni and subject experts with years of teaching experience</p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-center mb-3">
                              <div className="feature-icon me-3">🧪</div>
                              <div>
                                <h4 className="h5 mb-1">Hands-on Lab Sessions</h4>
                                <p className="mb-0">Practical training in well-equipped biotechnology laboratories</p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-center mb-3">
                              <div className="feature-icon me-3">📝</div>
                              <div>
                                <h4 className="h5 mb-1">Regular Mock Tests</h4>
                                <p className="mb-0">Weekly tests to gauge your preparation and identify weak areas</p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-center mb-3">
                              <div className="feature-icon me-3">🏆</div>
                              <div>
                                <h4 className="h5 mb-1">Performance Analysis</h4>
                                <p className="mb-0">Detailed performance reports and personalized improvement plans</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="program-schedule bg-white p-4 rounded shadow-sm">
                        <h3 className="h4 mb-4">Program Schedule</h3>
                        <div className="schedule-item mb-3 pb-3 border-bottom">
                          <div className="d-flex justify-content-between">
                            <h4 className="h5 mb-1">Foundation Phase</h4>
                            <span className="badge bg-primary">2 Months</span>
                          </div>
                          <p className="mb-0">Basic concepts and fundamentals across all topics</p>
                        </div>
                        <div className="schedule-item mb-3 pb-3 border-bottom">
                          <div className="d-flex justify-content-between">
                            <h4 className="h5 mb-1">Advanced Phase</h4>
                            <span className="badge bg-primary">3 Months</span>
                          </div>
                          <p className="mb-0">In-depth coverage of complex topics and problem-solving techniques</p>
                        </div>
                        <div className="schedule-item mb-3 pb-3 border-bottom">
                          <div className="d-flex justify-content-between">
                            <h4 className="h5 mb-1">Revision Phase</h4>
                            <span className="badge bg-primary">1 Month</span>
                          </div>
                          <p className="mb-0">Comprehensive revision and doubt clearing sessions</p>
                        </div>
                        <div className="schedule-item">
                          <div className="d-flex justify-content-between">
                            <h4 className="h5 mb-1">Test Series</h4>
                            <span className="badge bg-primary">Throughout</span>
                          </div>
                          <p className="mb-0">Regular mock tests under exam conditions</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          )}
        </Container>
      </section>

      {/* Internship Section */}
      <section className="internship-section py-5">
        <Container>
          <div className="section-heading text-center mb-5">
            <h2 className="fw-bold">Biotech + AI Internship Opportunities</h2>
            <p className="text-muted">Gain practical experience alongside your IIT-JAM preparation</p>
          </div>

          <Row className="g-4">
            {internships.map(internship => (
              <Col md={6} lg={4} key={internship.id}>
                <Card className="h-100 internship-card shadow">
                  <Card.Body>
                    <Badge bg="info" className="mb-3">Biotechnology + AI</Badge>
                    <Card.Title className="h4">{internship.title}</Card.Title>
                    <Card.Text>{internship.description}</Card.Text>
                    
                    <div className="d-flex justify-content-between mb-3">
                      <div>
                        <small className="text-muted d-block">Duration</small>
                        <strong>{internship.duration}</strong>
                      </div>
                      <div>
                        <small className="text-muted d-block">Stipend</small>
                        <strong>{internship.stipend}</strong>
                      </div>
                    </div>
                    
                    <div className="requirements mt-3">
                      <small className="text-muted d-block mb-2">Requirements:</small>
                      <ul className="ps-3 mb-0">
                        {internship.requirements.map((req, idx) => (
                          <li key={idx}>{req}</li>
                        ))}
                      </ul>
                    </div>
                  </Card.Body>
                  <Card.Footer className="bg-white border-0">
                    <Button variant="outline-primary" className="w-100">Apply Now</Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="internship-benefits mt-5">
            <Row className="g-4 align-items-center">
              <Col lg={6}>
                <div className="benefits-content p-4 bg-light rounded">
                  <h3 className="h4 mb-4">Why Choose Our Integrated Internship Program?</h3>
                  <div className="benefit-item d-flex mb-3">
                    <div className="benefit-icon me-3">🔬</div>
                    <div>
                      <h4 className="h5 mb-1">Real-world Experience</h4>
                      <p className="mb-0">Work on actual industry projects and research initiatives</p>
                    </div>
                  </div>
                  <div className="benefit-item d-flex mb-3">
                    <div className="benefit-icon me-3">🧠</div>
                    <div>
                      <h4 className="h5 mb-1">Applied Learning</h4>
                      <p className="mb-0">See how theoretical concepts from IIT-JAM syllabus apply in practice</p>
                    </div>
                  </div>
                  <div className="benefit-item d-flex mb-3">
                    <div className="benefit-icon me-3">📈</div>
                    <div>
                      <h4 className="h5 mb-1">Career Advancement</h4>
                      <p className="mb-0">Build your resume with prestigious internship experience</p>
                    </div>
                  </div>
                  <div className="benefit-item d-flex">
                    <div className="benefit-icon me-3">🤝</div>
                    <div>
                      <h4 className="h5 mb-1">Industry Connections</h4>
                      <p className="mb-0">Network with professionals and potential employers</p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="text-center">
                  <img src="/api/placeholder/500/400" alt="Students in biotech internship" className="img-fluid rounded shadow" />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default IITJAMBiotechPage;

// Add CSS for styling
export const additionalCSS = `
.hero-section {
  background: linear-gradient(135deg, #1a2a6c, #b21f1f, #fdbb2d);
  padding: 6rem 0;
}

.nav-tabs-custom {
  border-radius: 50px;
  overflow: hidden;
  display: inline-flex;
  border: 1px solid #dee2e6;
  background-color: white;
}

.nav-tabs-custom .nav-link {
  border-radius: 0;
  border: none;
  color: #495057;
  padding: 0.75rem 1.5rem;
}

.nav-tabs-custom .nav-link.active {
  background-color: #0d6efd;
  color: white;
}

.feature-icon {
  font-size: 1.75rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(13, 110, 253, 0.1);
}

.benefit-icon {
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-list {
  list-style: none;
  padding-left: 0;
}

.internship-card {
  transition: transform 0.3s ease;
}

.internship-card:hover {
  transform: translateY(-5px);
}

.book-card img {
  max-height: 200px;
  object-fit: cover;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 4rem 0;
  }
  
  .nav-tabs-custom {
    flex-wrap: wrap;
  }
  
  .nav-tabs-custom .nav-link {
    padding: 0.5rem 1rem;
  }
}

/* Create scrollable containers for content-heavy tabs */
.syllabus-container, .papers-container, .books-container {
  max-height: 600px;
  overflow-y: auto;
  padding-right: 5px;
}

.syllabus-container::-webkit-scrollbar,
.papers-container::-webkit-scrollbar,
.books-container::-webkit-scrollbar {
  width: 6px;
}

.syllabus-container::-webkit-scrollbar-thumb,
.papers-container::-webkit-scrollbar-thumb,
.books-container::-webkit-scrollbar-thumb {
  background-color: #dee2e6;
  border-radius: 3px;
}

.syllabus-container::-webkit-scrollbar-track,
.papers-container::-webkit-scrollbar-track,
.books-container::-webkit-scrollbar-track {
  background-color: #f8f9fa;
}
`;